import { Job } from '../../domain/models/job';
import { DashboardJobStatus } from '../enums/DashboardJobStatus';

export class RouteImport {
    public id: string;
    public name: string;
    public displayName: string;
    public minimumDelay: number;
    public editedMinimumDelay: number;

    public selected: boolean;
    public toRemove: boolean;
    public added: boolean;
    public status: DashboardJobStatus;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.minimumDelay = json.minimumDelay;
        }
        this.selected = false;
        this.toRemove = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/route-import.ts